import { watch } from 'vue'
import { cloneDeep } from 'lodash-es'
import { useUserProfileStore } from '@/ContextTab/stores/userProfile'


export async function usePassProfile() {

  const userProfile = useUserProfileStore()

  return async (legacyApp: any) => {
    legacyApp.$store.dispatch('userProfile/installProfile', {
      profile: cloneDeep(userProfile.profile),
      initial: true,
    })

    const updateProfile = async () => {
      legacyApp.$store.dispatch('panels/panelsSetUpdating', true)

      await legacyApp.$store.dispatch('userProfile/installProfile', {
        profile: cloneDeep(userProfile.profile),
      })

      legacyApp.$store.dispatch('panels/panelsSetUpdating', false)
    }

    watch(userProfile.profile, updateProfile)

    await legacyApp.$store.dispatch('panels/init')

    legacyApp.$store.dispatch('userProfile/init', 2)
  }
}
